import produce from "immer";
import filter from "lodash/filter";

import {
  CREATE_CONTENT_OF_PAGE_CMS_FAILURE,
  CREATE_CONTENT_OF_PAGE_CMS_REQUEST,
  CREATE_CONTENT_OF_PAGE_CMS_SUCCESS,
  CREATE_PAGE_CMS_FAILURE,
  CREATE_PAGE_CMS_REQUEST,
  CREATE_PAGE_CMS_SUCCESS,
  DELETE_CONTENT_OF_PAGE_CMS_FAILURE,
  DELETE_CONTENT_OF_PAGE_CMS_REQUEST,
  DELETE_CONTENT_OF_PAGE_CMS_SUCCESS,
  GET_PAGE_CMS_CONTENT_FAILURE,
  GET_PAGE_CMS_CONTENT_REQUEST,
  GET_PAGE_CMS_CONTENT_SUCCESS,
  GET_PAGE_CMS_FAILURE,
  GET_PAGE_CMS_REQUEST,
  GET_PAGE_CMS_SUCCESS,
  UPDATE_CONTENT_OF_PAGE_CMS_FAILURE,
  UPDATE_CONTENT_OF_PAGE_CMS_REQUEST,
  UPDATE_CONTENT_OF_PAGE_CMS_SUCCESS
} from "src/actions/cmsAction";

const initialState = {
  pages: [],
  content: [],
  loading: false,
  error: {}
};

const cmsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAGE_CMS_REQUEST: {
      return produce(state, (draft) => {
        draft.pages = [];
        draft.loading = true;
      });
    }
    case GET_PAGE_CMS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.pages = response;
        draft.loading = false;
      });
    }
    case GET_PAGE_CMS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    /**
     * @description: get content of page
     */
    case GET_PAGE_CMS_CONTENT_REQUEST: {
      return produce(state, (draft) => {
        // draft.content = [];
        draft.loading = true;
      });
    }
    case GET_PAGE_CMS_CONTENT_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.content = response;
        draft.loading = false;
      });
    }
    case GET_PAGE_CMS_CONTENT_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    /**
     * @description: Create page cms
     */
    case CREATE_PAGE_CMS_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case CREATE_PAGE_CMS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.pages = draft.pages.concat(response);
        draft.loading = false;
      });
    }

    case CREATE_PAGE_CMS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
        // Maybe user error
      });
    }
    /**
     * @description: create content of page
     */
    case CREATE_CONTENT_OF_PAGE_CMS_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case CREATE_CONTENT_OF_PAGE_CMS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.content = draft.content.concat(response);
        draft.loading = false;
      });
    }

    case CREATE_CONTENT_OF_PAGE_CMS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
        // Maybe user error
      });
    }
    /**
     * @description: Update content of page
     */
    case UPDATE_CONTENT_OF_PAGE_CMS_REQUEST: {
      return produce(state, (draft) => {
        // draft.pages = [];
        draft.loading = true;
      });
    }
    case UPDATE_CONTENT_OF_PAGE_CMS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.content = draft.content.concat(response);
        draft.loading = false;
      });
    }
    case UPDATE_CONTENT_OF_PAGE_CMS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    /**
     * @description Delete the content of the page
     */
    case DELETE_CONTENT_OF_PAGE_CMS_REQUEST: {
      return produce(state, (draft) => {
        // draft.pages = [];
        draft.loading = true;
      });
    }
    case DELETE_CONTENT_OF_PAGE_CMS_SUCCESS: {
      const {response} = action.payload;

      const deleteContent = filter(state.content, (i) => i.id !== response);
      if (deleteContent !== undefined && deleteContent.length > 0) {
        return produce(state, (draft) => {
          draft.content = deleteContent;
          draft.loading = false;
        });
      }
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case DELETE_CONTENT_OF_PAGE_CMS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
        // draft.error = response;
      });
    }
    default: {
      return state;
    }
  }
};

export default cmsReducer;
